// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import App from './App'
import router from './router'
import i18n from './lang/lang'
Vue.use(i18n)
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
import { store } from './store'
import VueLodash from 'vue-lodash'
const options = { name: 'lodash' } // customize the way you want to call it
Vue.use(VueLodash, options) // options is optional

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
moment.tz.setDefault('Europe/Budapest')
require('moment/locale/hu')
Vue.use(VueMoment, { moment })

import VueGtag from "vue-gtag";
Vue.use(VueGtag, { config: { id: "G-N40VLJ1YSL" } })

Vue.config.productionTip = false
// Loading
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading)

import { library } from '@fortawesome/fontawesome-svg-core'
// internal icons
import {
	faCheck,
	faUser,
	faUserCircle,
	faQuestion,
	faGavel,
	faHeart,
	faSearch,
	faShoppingBag,
	faFlag,
	faEdit,
	faArrowUp,
	faArrowDown,
	faUpload,
	faFileUpload,
	faHome,
	faEnvelope,
	faClock,
	faCalendarDay,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faChevronDown,
	faExclamationTriangle,
	faExclamation,
	faExclamationCircle,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDoubleUp,
	faEye,
	faEyeSlash,
	faCaretDown,
	faCaretUp,
	faMinus,
	faPlus,
	faSyncAlt,
	faDollarSign,
	faEuroSign,
	faTags,
	faGlobe,
	faShoppingCart,
	faEraser,
	faCashRegister,
	faExternalLinkAlt,
	faTachometerAlt
} from '@fortawesome/free-solid-svg-icons'
import {
	faFacebookF
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './style/htauction.scss'
library.add(
	faCheck,
	faUser,
	faUserCircle,
	faQuestion,
	faGavel,
	faHeart,
	faSearch,
	faShoppingBag,
	faFlag,
	faEdit,
	faArrowUp,
	faArrowDown,
	faUpload,
	faFileUpload,
	faHome,
	faEnvelope,
	faClock,
	faCalendarDay,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faChevronDown,
	faExclamationTriangle,
	faExclamation,
	faExclamationCircle,
	faAngleLeft,
	faAngleRight,
	faAngleUp,
	faAngleDoubleUp,
	faEye,
	faEyeSlash,
	faCaretDown,
	faCaretUp,
	faMinus,
	faPlus,
	faSyncAlt,
	faDollarSign,
	faEuroSign,
	faTags,
	faGlobe,
	faShoppingCart,
	faEraser,
	faCashRegister,
	faExternalLinkAlt,
	faFacebookF,
	faTachometerAlt
)

Vue.component('vue-fontawesome', FontAwesomeIcon)

import Buefy from 'buefy'
Vue.use(Buefy, {
	defaultIconComponent: 'vue-fontawesome',
	defaultIconPack: 'fas',
})

import VueSocketIO from 'vue-socket.io'
import io from 'socket.io-client'
import axios from 'axios'
import CancelToken from 'axios'
import VueSessionStorage from 'vue-sessionstorage'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
Vue.use(VueSessionStorage)
Vue.prototype.$backendUrl = '/'
var _token = localStorage.getItem('token')
_token = _token ? _token.split(' ')[1] : ''
Vue.use(
	new VueSocketIO({
		debug: true,
		connection: io('/', {
			query: 'auth_token=' + _token,
		}),
		vuex: {
			store,
			actionPrefix: 'SOCKET_',
			mutationPrefix: 'SOCKET_',
		},
	})
)

Vue.config.productionTip = false

axios.defaults.baseURL = '/'

Vue.filter('toCurrency', function (_value, _this, _to_currency) {
	if (typeof _value !== 'number') {
		return _value
	}

	_value = _value / _this.$store.getters.currencies[_to_currency.toLowerCase()]
	_value = Math.ceil(_value)

	/*  var formatter = new Intl.NumberFormat(i18n.locale, {
    style: 'currency',
    currency: _to_currency,
    minimumFractionDigits: 0
  })
*/
	var formatter = new Intl.NumberFormat(i18n.locale, {
		style: 'currency',
		currency: _to_currency,
		minimumFractionDigits: 0,
	})

	var formatted = formatter.format(_value)
	if (formatted.indexOf('Ft') > -1) {
		var _temp = formatted.split(/(\s+)/)
		var temp = _temp[0].split('').reverse()
		var res = []
		for (var i = 1; i <= temp.length; i++) {
			res.push(temp[i - 1])
			if (i % 3 == 0) {
				res.push(' ')
			}
		}
		_temp[0] = res.reverse().join('')
		return _temp.join('')
	} else {
		return formatted
	}

	//return formatter.format(_value)
})

Vue.filter('fmtCurrency', function (_value, _to_currency) {
	var _value2 = parseInt(_value)

	if (typeof _value2 !== 'number' || isNaN(_value2)) {
		return _value
	}
	var formatter = new Intl.NumberFormat(i18n.locale, {
		style: 'currency',
		currency: _to_currency,
		minimumFractionDigits: 0,
	})
	return formatter.format(_value2)
})
Vue.filter('toUserCurrency', function (_value, _this, _ceil) {
	if (typeof _value !== 'number' || _this == null) {
		return _value
	}
	var _to_currency = _this.$store.getters.userpref ? _this.$store.getters.userpref.currency : 'HUF'
	if (_this.$store.getters.currencies[_to_currency.toLowerCase()]) {
		_value = _value / _this.$store.getters.currencies[_to_currency.toLowerCase()]
	} else {
		_to_currency == 'huf'
		_value = _value / 1
	}
	if (_ceil) {
		_value = Math.ceil(_value)
	}

	var formatter = new Intl.NumberFormat(i18n.locale, {
		style: 'currency',
		currency: _to_currency,
		minimumFractionDigits: 0,
	})

	var formatted = formatter.format(_value)
	if (formatted.indexOf('Ft') > -1) {
		var _temp = formatted.split(/(\s+)/)
		var temp = _temp[0].split('').reverse()
		var res = []
		for (var i = 1; i <= temp.length; i++) {
			res.push(temp[i - 1])
			if (i % 3 == 0) {
				res.push(' ')
			}
		}
		_temp[0] = res.reverse().join('')
		return _temp.join('')
	} else {
		return formatted
	}
})

Vue.filter('moment', function (date) {
	if (localStorage.getItem('lang') == 'hu') {
		return moment(date).format('YYYY.MM.DD. HH:mm')
	}
	return moment(date).format('MM/DD/YYYY, h:mm A')
})

Vue.filter('fromToCurrency', function (_value, _this, _from_currency, _to_currency) {
	var fromRate,
		toRate,
		orig = _value
	if (typeof _value !== 'number') {
		_value = parseFloat(_value)
		if (isNaN(_value)) {
			return orig
		}
	}
	fromRate = _this.$store.getters.currencies[_from_currency.toLowerCase()]
	toRate = _this.$store.getters.currencies[_to_currency.toLowerCase()]
	//console.log('..........',fromRate, toRate, _from_currency, _to_currency, _value, _this.$store.getters.currencies);
	if (fromRate && toRate) {
		return (_value * fromRate) / toRate
	}
	return orig
})

Vue.filter('toCeil', function (_value) {
	return Math.ceil(_value)
})

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.toUpperCase()
})

Vue.filter('capFirstChar', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('toFixed', function (value, decimals) {
	if (!value) return ''
	value = parseFloat(value).toFixed(decimals)
	var formatter = new Intl.NumberFormat(i18n.locale, {
		style: 'decimal',
		minimumFractionDigits: decimals,
	})
	return formatter.format(value)
})

var filter = function (text, length, clamp) {
	clamp = clamp || '…'
	var node = document.createElement('div')
	node.innerHTML = text
	var content = node.textContent
	return content.length > length ? content.slice(0, length) + clamp : content
}

Vue.filter('truncate', filter)
/*
 * d param is a duration moment object
 */
Vue.prototype.remTimeFormat = function (now, finish) {
	var num = true
	var time = moment(now)
	var d = moment.duration(-1 * time.diff(finish))
	var countdown = ''

	if (d.days() || d.months() || d.years()) countdown += Math.floor(d.asDays()) + ' ' + i18n.tc('days', d.asDays()) + ' '
	if (d.months() < 1 && d.years() < 1) {
		countdown += d.hours().toString().padStart(2, '0') + (num ? ':' : ' ' + i18n.tc('hours', d.hours()) + ' ')
		countdown += d.minutes().toString().padStart(2, '0') + (num ? ':' : ' ' + i18n.tc('minutes', d.minutes()) + ' ')
		countdown += d.seconds().toString().padStart(2, '0') + (num ? '' : ' ' + i18n.tc('seconds', d.seconds()))
	}
	return countdown
}

var baseServerUrl = '/v1/'
Vue.prototype.$baseServerUrl = baseServerUrl

export const globalStore = new Vue({
	data: {
		user: {},
		loggedIn: false,
		token: null,
	},
})
Vue.prototype.$globals = globalStore

Vue.use(axios)
Vue.use(CancelToken)
Vue.prototype.$http = axios.create({
	baseURL: baseServerUrl,
	timeout: 90000,
	//responseType: 'json',
	headers: {
		'Content-Type': 'application/json',
		Authorization: localStorage.getItem('token'),
	},
	//data:{XXX:"-"}
})
Vue.prototype.$httpBase = axios.create({
	baseURL: baseServerUrl,
	timeout: 90000,
	/* headers:{
    "Accept-Language": 'en-EN,en;'
  }*/
})

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth) || to.matched.some((record) => record.meta.admin)) {
		console.log('CHK AUTH REQUIRED', typeof app)
		if (typeof app === 'undefined') {
			var app = router.app
		}

		if (app) {
			console.log('CHK USER START', to.fullPath)
			app.$checkLoggedIn(
				app,
				function (err) {
					if (err) {
						next({
							path: '/login',
							query: { redirect: to.fullPath },
						})
					}
				},
				true
			)
		}
		if (router.app && router.app.$store.getters.loggedIn == 'false') {
			console.log('LOGGED IN FALSE -> REDIRECT:', to.fullPath)
			next({
				path: '/login',
				query: { redirect: to.fullPath },
			})
		} else if (localStorage.loggedIn == 'false') {
			console.log('APP not found', app)
			next({
				path: '/login',
				query: { redirect: to.fullPath },
			})
		} else {
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
})

// router.beforeEach((to, from, next) => {
// 	document.title = to.meta.title == undefined ? 'HTaukcio' : to.meta.title
// 	next()
// })

var lastCheck = null
Vue.prototype.$checkLoggedIn = function (_this, callback, force) {
	if (
		force == true ||
		lastCheck == null ||
		_this.$store.getters.loggedIn == false ||
		_this.$moment().diff(lastCheck, 'seconds') > 10
	) {
		lastCheck = _this.$moment()
		if (
			(localStorage.getItem('token') == null || typeof localStorage.getItem('token') == 'undefined') &&
			localStorage.loggedIn == 'false'
		) {
			localStorage.removeItem('loggedIn')
			callback(null, null)
			//_this.$router.push({ name: "Login" });;
		} else {
			_this.$http
				.get('/users')
				.then(function (response) {
					console.log('GET USER RESP:', response.data)
					if (response.data.success) {
						_this.$store.commit('setUser', response.data.user)
						console.log('XX1')
						if (response.data.user.UserPreference) {
							if (localStorage.getItem('lang') === null) {
								localStorage.setItem('lang', response.data.user.UserPreference.language.toLowerCase())
							}
							localStorage.setItem('currency', response.data.user.UserPreference.currency)
						}
						localStorage.loggedIn = true
						//_this.$i18n.locale = response.data.user.language;
						callback(null, response.data)
					} else {
						localStorage.removeItem('loggedIn')
						_this.$store.commit('setUser', {})
						_this.$store.commit('setLoggedIn', false)
						callback('not success', null)
						// _this.$router.push({ name: "Login" });
					}
				})
				.catch(function (error) {
					localStorage.removeItem('loggedIn')
					_this.$store.commit('setUser', {})
					_this.$store.commit('setLoggedIn', false)
					localStorage.setItem('loggedIn', false)
					//_this.$router.push({ name: "Login" });
					callback(error.response.data, null)
				})
		}
	}
}

/**
 *
 *   Application components
 *
 */

import MainMenu from '@/components/common/MainMenu'
import Footer from '@/components/common/Footer'

Vue.component('MainMenu', MainMenu)
Vue.component('Footer', Footer)

export const app = new Vue({
	el: '#app',
	store,
	i18n,
	router,
	components: { App },
	template: '<App/>',
})
